export default __webpack_public_path__ + "static/media/HBTC-USDT.6e85c650.png";